<template>
    <div class="page newpage">
		<div class="_flex_sb">
			<div class="left bag_f5 p_10 br_8" style="width: 160px;">
				<div class="_flex _f_ai h40 cp bb1sd">业务表单</div>
				<div class="_flex _f_ai h40 cp _color bb1sd" @click="tableCreate">
					<span class="b1s mr_5 br_4 lh_14" style="display: inline-block;">＋</span>自建表单
				</div>
				<div class="_flex _f_ai h40 cp bb1sd" :class="{mun_active: tableCurrent.name == item.name}" v-for="(item,index) in tableArr" :key="index" @click="changeTable(item)">
                    <span style="margin-right: 10px;">{{item.comment}}</span>
                    <span v-if="item.is_customize" class="_button p_0 f_10 bag_green" style="padding: 0 2px;">自建</span>
                    <i class="el-icon-setting f_18" v-if="tableCurrent.name == item.name"></i>
                </div>
			</div>
			<div class="right" style="width: calc(100% - 160px - 50px);">
				<div style="display: flex;justify-content: space-between;align-items: center;">
					<div><span v-if="tableCurrent.name">《<span class="_color">{{tableCurrent.comment}}</span>》表结构</span></div>
                    <el-tabs v-model="fieldSearch.filter" @tab-click="handleTabfilter">
                        <el-tab-pane label="全部" name="all" class="_tabber_item"></el-tab-pane>
                        <el-tab-pane label="自定义" name="customize"></el-tab-pane>
                        <el-tab-pane label="系统" name="system"></el-tab-pane>
                    </el-tabs>
					<el-button type="success" size="small" :disabled="!tableCurrent.name" @click="fieldAdd">添加字段</el-button>
				</div>
				<el-table :data="fieldArr" stripe :header-cell-style="{ background:'#f5f5f5'}">
				    <el-table-column type="index" label="序号"> </el-table-column>
				    <el-table-column prop="id" label="编号" ></el-table-column>
				    <el-table-column prop="title" label="字段名" ></el-table-column>
				    <el-table-column prop="comment" label="说明" ></el-table-column>
				    <el-table-column prop="type_text" label="类型" ></el-table-column>
				    <el-table-column prop="state_text" label="状态" ></el-table-column>
				    <el-table-column prop="is_customize_text" label="属性" ></el-table-column>
				    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="_flex" v-if="scope.row.is_customize">
                                <el-button size="mini" type="primary" @click="fieldEdit(scope.row)">编辑</el-button>
                                <el-button size="mini" type="danger" @click="fieldDelete(scope.row)">删除</el-button>
                            </div>
                        </template>
				    </el-table-column>
				  </el-table>
			</div>
		</div>
		
		<el-drawer title="字段详情" :visible.sync="represShow" direction="rtl" @close="represShow=false">
		  <el-form label-position="right" label-width="90px" :model="formData" style="padding: 0 8% 0 5%;">
				<el-form-item label="编号：">{{fieldCurrent.id ? fieldCurrent.id : ''}}</el-form-item>
				<el-form-item label="名称：">
				  <el-input v-model="fieldCurrent.title"></el-input>
				</el-form-item>
				<el-form-item label="说明：">
				  <el-input v-model="fieldCurrent.comment"></el-input>
				</el-form-item>
				<el-form-item label="排序：">
				   <el-input v-model="fieldCurrent.sort"></el-input>
			   </el-form-item>
				<el-form-item label="类型：">
                  <el-select v-model="fieldCurrent.type" placeholder="请选择">
                    <el-option v-for="typeItem in types" :key="typeItem.name" :label="typeItem.name" :value="typeItem.flag"> </el-option>
                  </el-select>
			  </el-form-item>
				<div v-if="fieldCurrent.type == 'option' || fieldCurrent.type == 'multi_option'">
                    <el-form-item label="默认取值：">
                        <a class="fr _color" @click="addOptions"><span class="b1s mr_5 lh_14" style="display: inline-block;">＋</span>添加选项</a>
                    </el-form-item>
                    <el-form-item label="">
                        <div class="bag_d pl_10 pr_20 br_4" style="margin-bottom: 10px;" v-for="(option,oindex) in fieldCurrent.options" :key="oindex">
                            {{option.name}}
                            <span class="f_18 fr">
                                <a class="el-icon-top c3" @click="upOptions(option)"></a>
                                <a class="el-icon-edit blue m_5" @click="addOptions(option)"></a>
                                <a class="el-icon-delete red" @click="delOptions(option)"></a>
                            </span>
                        </div>
                    </el-form-item>
                </div>
                <div class="t_c mt_20" style="bottom: 10px;width: 100%;">
                    <el-button @click="represShow=false">取 消</el-button>
                    <el-button type="primary" :loading="loading" @click="fieldSubmit">确 定</el-button>
                </div>
		  </el-form>
		</el-drawer>
		
		<el-dialog title="编辑选项值" :visible="show" width="500px" center @close="show=false">
		  <el-form label-position="right" label-width="100px" :model="optionCurrent" class="pr_20">
		    <el-form-item label="ID：">{{optionCurrent.id ? optionCurrent.id : ''}}</el-form-item>
			<el-form-item label="名称：">
		      <el-input v-model="optionCurrent.name"></el-input>
		    </el-form-item>
		    <el-form-item label="说明：">
		      <el-input v-model="optionCurrent.desc"></el-input>
		    </el-form-item>
		    <div class="t_c mt_20">
				<el-button size="middle" @click="show=false">取 消</el-button>
				<el-button type="primary" size="middle" @click="optionSubmit">确 定</el-button>
		    </div>
		  </el-form>
		</el-dialog>

        <el-dialog title="自建表单" :visible="createtableVisible" width="500px" center @close="createtableVisible=false">
            <el-form label-position="right" label-width="100px" :model="optionCurrent" class="pr_20">
              <el-form-item label="名称：">
                <el-input v-model="tableForm.table"></el-input>
              </el-form-item>
              <el-form-item label="说明：">
                <el-input v-model="tableForm.comment"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="createtableVisible=false">取 消</el-button>
                <el-button type="primary" :loading="tableloading" @click="tableSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { tableLists, fieldLists, field, fieldDel, createtable, } from "../../request/apis.js"
export default{
    components: { },
    data(){
        return {
            createtableVisible: false,
            tableFormInit: {table: '', comment: ''},
            tableForm: {},
            types: [],
            tableCurrent: {},
            tableArr: [],
            fieldCurrent: {},
            fieldInit: {title: '', comment: '', sort: 50, type: '', options: []},
            fieldArr: [],
            optionCurrent: {},
            optionSort: 0,
            optionInit: {name: '', sort: 50, state: 1, desc: ''},
			name:'',
			show : false,
			represShow : false,
			formData : {
				name : '',
				list : [{val:'张三'}]
			},
            tabfilter: 'all',
            fieldSearch: {
                table: '',
                filter: 'all',
            },
            loading: false,
            tableloading: false,
        }
    },
	mounted() {
        this.getTableLists();
	},
	methods:{
        async getTableLists(){
            var res = await tableLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.tableArr = res.data.tables;
            this.types = res.data.types;
        },
        tableCreate(){
            this.tableForm = {...this.tableFormInit};
            this.createtableVisible = true;
        },
        async tableSubmit(){
            this.tableloading = true;
            let res = await createtable(this.tableForm);
            this.tableloading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.createtableVisible = false;
            this.getTableLists();
        },
        changeTable(table){
            this.tableCurrent = table;
            this.fieldSearch.table = table.name;
            this.getFieldLists();
        },
        async getFieldLists(){
            if(!this.fieldSearch.table){
                return this.$message.error('请选择表单');
            }
            var res = await fieldLists(this.fieldSearch);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.fieldArr = res.data;
        },
        fieldAdd(){
            this.fieldCurrent = JSON.parse(JSON.stringify(this.fieldInit));
            this.represShow = true;
        },
        fieldEdit(data){
            this.fieldCurrent = JSON.parse(JSON.stringify(data));
            this.represShow = true;
        },
        upOptions(option){
            const options = this.fieldCurrent.options;
            const index = options.indexOf(option);
            if (index > 0) {
                [options[index], options[index - 1]] = [options[index - 1], options[index]];
            }
            this.$forceUpdate();
        },
        addOptions(option = null){
            this.optionCurrent = option.name ? option : {...this.optionInit}
            this.show = true;
        },
        optionSubmit(){
            const options = this.fieldCurrent.options;
            const index = options.findIndex(option => option.name === this.optionCurrent.name);
            if (index !== -1) {
                this.$set(options, index, { ...this.optionCurrent });
            } else {
                options.push({ ...this.optionCurrent });
            }
            this.show = false;
            this.optionCurrent = { ...this.optionInit };
        },
        delOptions(option){
            this.fieldCurrent.options.splice(this.fieldCurrent.options.indexOf(option), 1);
        },
        async fieldSubmit(){
            this.loading = true;
            let res = await field({...this.fieldCurrent, table: this.tableCurrent.name});
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.represShow = false;
            this.getFieldLists();
        },
        fieldDelete(field){
            this.$confirm('此操作将永久删除该字段, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await fieldDel({id: field.id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '删除成功');
                this.getFieldLists();
            }).catch(() => {});
        },
        handleTabfilter(){
            this.getFieldLists();
        },
	}
}
</script>

<style  scoped>
.mun_active{
	background-color: var(--theme-color);
	color: #fff;
	margin: 0 -10px;
	padding:0 10px;
	display: flex;
	justify-content: space-between;
	border-radius: 6px;
}
</style> 